import { render, staticRenderFns } from "./creSIcreate.vue?vue&type=template&id=f1c86212&scoped=true"
import script from "./creSIcreate.vue?vue&type=script&lang=js"
export * from "./creSIcreate.vue?vue&type=script&lang=js"
import style0 from "./creSIcreate.vue?vue&type=style&index=0&id=f1c86212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c86212",
  null
  
)

export default component.exports